export const B2C = {
  accountName: 'decathlonstore',
  checkoutUrl: '/checkout/cart',
  accountUrl: '/account',
  salesChannel: 3,
  gtmContainerId: 'GTM-T777CVM',
  loginUrl: 'https://secure.decathlon.com.br/api/io/login',
}
